import React, { Component } from "react";
import AppActions from "../flux/AppActions";


class PageNotFound extends Component {

    constructor(props) {
        super( props );

        this.inputRef = React.createRef();
    }

    componentDidMount() {
        AppActions.updatePage('none');
    }

    __updatePage(e){
        e.preventDefault();
        AppActions.updatePage('home');
    }

    render() {
        const locale = this.props.locale;
        return (
            <div className={"page-about"}>
                <h3>Page: Not Found</h3>
                <input type={"submit"} onClick={this.__updatePage.bind(this)} value={"Home"}/>
            </div>
        );
    }

}

export default PageNotFound;
